import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ListaBase } from '../../../shared/crud/ListaBase';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { DealerItem, Regional, FluxoLeadsResponse } from './fluxo-leads.model';
import { FiltroService } from '../../../shared/filtro/filtro.service';
import { FluxoLeadsService } from './fluxo-leads.service';
import { FiltroDealers } from './filtro-dealer';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexPlotOptions,
  ApexXAxis,
  ApexDataLabels,
  ApexFill,
  ApexTooltip,
  ApexLegend
} from 'ng-apexcharts';

@Component({
  selector: 'app-fluxo-leads',
  templateUrl: './fluxo-leads.component.html',
  styleUrls: ['./fluxo-leads.component.css']
})
export class FluxoLeadsComponent extends ListaBase implements OnInit {
  regionais: Regional[] = [];
  regionalSelecionada: Regional | null = null;
  visualizandoTotal: boolean = false;
  dadosFluxoLeads: FluxoLeadsResponse | null = null;
  loadingFluxoLeads = false;
  loadingGraficoPizza = false;
  loadingGraficoFunil = false;
  loadingTabela = false;
  
  // Cache de dealers por regional
  dealersRegionalCache: any[] = [];
  dealersRegionalCarregado = false;

  // Columns (mantido da estrutura original)
  subscription;
  columns: any[];
  _selectedColumns: any[];
  loading = false;
  @Input() filtros: any;
  dealers = [];
  selectedDealer: any;
  selecionados = [];
  display: boolean = false;
  filterName: any[];
  nomeModulo: string;
  
  // Filtros
  filtroDealers: FiltroDealers;
  data_inicial: Date;
  data_final: Date;
  displayFiltrosDealers: boolean = false;

  // Gráfico de Pizza
  graficoPizza: any;
  optionsPizza: any;
  plugins = [pluginDataLabels];

  // Gráfico Funil
  chartOptionsFunil: Partial<{
    series: ApexAxisChartSeries;
    chart: ApexChart;
    plotOptions: ApexPlotOptions;
    xaxis: ApexXAxis;
    dataLabels: ApexDataLabels;
    fill: ApexFill;
    tooltip: ApexTooltip;
    legend: ApexLegend;
  }>;

  dadosTranslate = {}

  constructor(
    service: FluxoLeadsService,
    toastr: ToastrService,
    router: Router,
    private filtroService: FiltroService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private servico: FluxoLeadsService) {
    super(service, toastr, router);
    this.filtros = {};
    this.nomeModulo = 'fluxo-leads';
    this.filtroDealers = new FiltroDealers();
  }

  ngOnInit() {
    this.definirDatasPadrao();
    this.carregarDadosIniciais();
    this.changeLanguageValue();
  }

  carregarDadosIniciais() {
    this.loading = true;
    
    // Carrega dealers regionais e regionais em paralelo
    Promise.all([
      this.servico.buscarRegionais(),
      this.servico.buscarDealersRegional()
    ]).then(([regionais, dealersRegional]) => {
      this.regionais = regionais;
      this.dealersRegionalCache = dealersRegional;
      this.dealersRegionalCarregado = true;
      
      this.loading = false;
      
      // Seleciona a primeira regional automaticamente se houver
      if (this.regionais.length > 0) {
        this.selecionarRegional(this.regionais[0]);
      }
    }).catch(error => {
      this.loading = false;
      console.error('Erro ao carregar dados iniciais:', error);
    });
  }

  // Métodos para Fluxo de Leads

  selecionarRegional(regional: Regional) {
    this.regionalSelecionada = regional;
    this.visualizandoTotal = false;
    
    // Limpa dealers selecionados ao trocar de regional
    this.filtroDealers.limparSelecionados();
    
    this.atualizarDealersDisponiveis();
    this.aplicarFiltros();
  }

  selecionarTotal() {
    this.regionalSelecionada = null;
    this.visualizandoTotal = true;
    
    // Limpa dealers selecionados ao trocar para total
    this.filtroDealers.limparSelecionados();
    
    this.atualizarDealersDisponiveis();
    this.aplicarFiltros();
  }

  atualizarDealersDisponiveis() {
    if (!this.dealersRegionalCarregado || !this.dealersRegionalCache || this.dealersRegionalCache.length === 0) {
      return;
    }

    if (this.visualizandoTotal) {
      // Se for Total, mostra todos os dealers de todas as regionais
      const todosDealers = [];
      this.dealersRegionalCache.forEach(regional => {
        if (regional.dealers && regional.dealers.length > 0) {
          regional.dealers.forEach(dealer => {
            // Evita duplicatas
            if (!todosDealers.find(d => d.id === dealer.id)) {
              todosDealers.push({
                id: dealer.id,
                nome: dealer.descricao,
                selecionado: false
              });
            }
          });
        }
      });
      this.dealers = todosDealers;
      this.filtroDealers.preencher(todosDealers);
    } else if (this.regionalSelecionada) {
      // Busca os dealers da regional selecionada
      const regionalNome = this.regionalSelecionada.nome || this.regionalSelecionada.descricao || '';
      
      // Busca mais flexível
      const regionalEncontrada = this.dealersRegionalCache.find(r => {
        const nomeCache = (r.nome || '').toLowerCase().trim();
        const nomeSelecionado = regionalNome.toLowerCase().trim();
        
        return nomeCache === nomeSelecionado || 
               nomeCache.includes(nomeSelecionado) ||
               nomeSelecionado.includes(nomeCache);
      });

      if (regionalEncontrada && regionalEncontrada.dealers && regionalEncontrada.dealers.length > 0) {
        const dealersFiltrados = regionalEncontrada.dealers.map(dealer => ({
          id: dealer.id,
          nome: dealer.descricao,
          selecionado: false
        }));
        this.dealers = dealersFiltrados;
        this.filtroDealers.preencher(dealersFiltrados);
      } else {
        this.dealers = [];
        this.filtroDealers.preencher([]);
      }
    }
  }

  aplicarFiltros() {
    if (!this.regionalSelecionada && !this.visualizandoTotal) {
      const mensagem = this.translate.instant('fluxoLeads.selecioneRegionalOuTotal');
      const titulo = this.translate.instant('barraCrud.atencao');
      this.toastr.warning(mensagem, titulo);
      return;
    }

    const filtros = this.montarFiltros();
    
    if (this.visualizandoTotal) {
      this.carregarDadosFluxoLeads(null, filtros);
    } else {
      this.carregarDadosFluxoLeads(this.regionalSelecionada.id, filtros);
    }
  }

  private montarFiltros(): any {
    const filtros: any = {};

    // Dealers selecionados
    const dealersSelecionados = this.filtroDealers.selecionados();
    if (dealersSelecionados && dealersSelecionados.length > 0) {
      filtros.dealers = dealersSelecionados.map(d => d.id);
    }

    // Datas
    if (this.data_inicial) {
      filtros.data_inicial = this.formatarDataParaAPI(this.data_inicial);
    }
    if (this.data_final) {
      filtros.data_final = this.formatarDataParaAPI(this.data_final);
    }

    return filtros;
  }

  carregarDadosFluxoLeads(idRegional: number | null, filtros?: any) {
    // Ativa todos os loadings
    this.loadingGraficoPizza = true;
    this.loadingGraficoFunil = true;
    this.loadingTabela = true;
    
    // Busca dados de fluxo de leads (pizza e tabela)
    this.servico.buscarFluxoLeadsPorRegional(idRegional, filtros)
      .then(dadosFluxo => {
        this.dadosFluxoLeads = dadosFluxo;
        
        // Configura gráfico de pizza
        this.configurarGraficoPizza();
        this.loadingGraficoPizza = false;
        
        // Desativa loading da tabela
        this.loadingTabela = false;
      })
      .catch(error => {
        this.loadingGraficoPizza = false;
        this.loadingTabela = false;
        this.dadosFluxoLeads = null;
        console.error('Erro ao carregar dados de fluxo de leads:', error);
      });
    
    // Busca dados de classificação (funil) - formato DD-MM-YYYY - independente
    const dataInicialClassificacao = this.formatarDataParaClassificacao(this.data_inicial);
    const dataFinalClassificacao = this.formatarDataParaClassificacao(this.data_final);
    const dealers = filtros?.dealers || [];
    
    this.servico.buscarClassificacao(dataInicialClassificacao, dataFinalClassificacao, idRegional, dealers)
      .then(dadosClassificacao => {
        this.configurarGraficoFunil(dadosClassificacao);
        this.loadingGraficoFunil = false;
      })
      .catch(error => {
        this.loadingGraficoFunil = false;
        console.error('Erro ao carregar dados de classificação:', error);
      });
  }

  private formatarDataParaAPI(data: Date): string {
    if (!data) return null;
    
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    
    return `${ano}-${mes}-${dia}`;
  }

  private formatarDataParaClassificacao(data: Date): string {
    if (!data) return null;
    
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    
    return `${dia}-${mes}-${ano}`;
  }

  configurarGraficoPizza() {
    if (!this.dadosFluxoLeads) return;

    const labels = this.dadosFluxoLeads.categorias;
    const dados = labels.map(cat => this.dadosFluxoLeads.total_regiao.valores[cat]);

    this.graficoPizza = {
      labels: labels,
      datasets: [{
        data: dados,
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0',
          '#9966FF'
        ]
      }]
    };

    this.optionsPizza = {
      legend: {
        position: 'left',
        labels: {
          boxWidth: 20
        }
      },
      plugins: {
        datalabels: {
          color: '#000',
          font: {
            weight: 'bold'
          },
          formatter: (value: number, context: any) => {
            const data = context.chart.data.datasets[0].data;
            const total = data.reduce((sum: number, val: number) => sum + val, 0);

            if (value === 0) return '';

            const percent = ((value / total) * 100).toFixed(2);
            return `${percent}%`;
          }
        }
      }
    };
  }

  configurarGraficoFunil(dadosClassificacao?: any) {
    if (!dadosClassificacao || !dadosClassificacao.etapas) {
      // Dados padrão se não houver dados da API
      const dadosFunil = [
        { label: 'Visitou Showroom', valor: 0 },
        { label: 'Fez Test-Drive', valor: 0 },
        { label: 'Em Negociação', valor: 0 },
        { label: 'Vendas', valor: 0 }
      ];
      
      this.criarGraficoFunil(dadosFunil);
      return;
    }

    const etapas = dadosClassificacao.etapas;
    
    // Encontrar o índice de "Visitou Showroom"
    let indexShowroom = etapas.findIndex((etapa: any) => 
      etapa.label.toLowerCase().includes('visitou') && etapa.label.toLowerCase().includes('showroom')
    );
    
    // Se não encontrar, procurar apenas por "showroom"
    if (indexShowroom === -1) {
      indexShowroom = etapas.findIndex((etapa: any) => 
        etapa.label.toLowerCase().includes('showroom')
      );
    }
    
    // Se encontrou, pega desse índice pra frente, senão pega tudo
    const etapasFiltradas = indexShowroom !== -1 ? etapas.slice(indexShowroom) : etapas;
    
    this.criarGraficoFunil(etapasFiltradas);
  }

  private criarGraficoFunil(dadosFunil: Array<{label: string, valor: number}>) {
    const valores = dadosFunil.map(e => e.valor);
    const leadMax = Math.max(...valores, 1); // Mínimo 1 para evitar divisão por zero
    const empurrar = valores.map(v => (leadMax - v) / 2);

    this.chartOptionsFunil = {
      series: [
        { name: '', data: empurrar },
        { name: 'Valor', data: valores }
      ],
      chart: {
        type: 'bar',
        stacked: true,
        height: Math.max(dadosFunil.length * 60, 200),
        toolbar: { show: false }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '70%'
        }
      },
      xaxis: {
        categories: dadosFunil.map(e => e.label),
        max: leadMax,
        tickAmount: 4,
      },
      fill: {
        colors: ['transparent', '#3b82f6']
      },
      tooltip: {
        shared: true,
        intersect: false,
        enabledOnSeries: [1],
        y: {
          formatter: function (val: number) {
            const percent = leadMax > 0 ? ((val / leadMax) * 100).toFixed(1) : '0';
            return `${val} (${percent}%)`;
          }
        }
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1],
        style: {
          colors: ['#ffffff'],
          fontSize: '12px',
          fontWeight: 'bold'
        },
        formatter: function (val: number) {
          return val.toString();
        }
      },
      legend: {
        show: false
      }
    };
  }

  getPercentualFormatado(valor: number): string {
    if (valor === null || valor === undefined) {
      return '-';
    }
    return valor.toFixed(2) + '%';
  }

  isRegionalSelecionada(regional: Regional): boolean {
    return this.regionalSelecionada?.id === regional.id;
  }

  isTotalSelecionado(): boolean {
    return this.visualizandoTotal;
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.carregarDadosIniciais();
      });
  }

  trackByRegionalId(index: number, regional: Regional): any {
    return regional ? regional.id : index;
  }

  trackByDealerId(index: number, dealer: any): any {
    return dealer ? dealer.id_dealer : index;
  }

  getNomeRegional(regional: Regional, index: number): string {
    // Tenta usar o nome, se não tiver usa a descrição, senão gera um nome baseado no índice
    if (regional.nome && regional.nome.trim()) {
      return regional.nome.trim();
    }
    if (regional.descricao && regional.descricao.trim()) {
      return regional.descricao.trim();
    }
    return `Região ${index + 1}`;
  }

  // Métodos de Filtros
  private preencherDealers() {
    this.filtroService.buscar('dealer')
      .then(res => { 
        this.dealers = res.filtros;
        this.filtroDealers.preencher(res.filtros);
      });
  }

  selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  removerDealer(dealer: any) {
    dealer.selecionado = false;
  }

  onAdicionarDealerFiltro(dealer: DealerItem) {
    dealer.selecionado = true;
  }

  private definirDatasPadrao() {
    const hoje = new Date();
    const inicioDoMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    
    this.data_inicial = inicioDoMes;
    this.data_final = hoje;
  }

  limpaDataInicial() {
    const hoje = new Date();
    const inicioDoMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    this.data_inicial = inicioDoMes;
  }

  limpaDataFinal() {
    const hoje = new Date();
    this.data_final = hoje;
  }

  onDataInicialChange() {
    if (this.data_inicial && this.data_final && this.data_inicial > this.data_final) {
      const novaDataFinal = new Date(this.data_inicial);
      novaDataFinal.setDate(novaDataFinal.getDate() + 1);
      this.data_final = novaDataFinal;
    }
  }

  onDataFinalChange() {
    if (this.data_inicial && this.data_final && this.data_final < this.data_inicial) {
      const novaDataInicial = new Date(this.data_final);
      novaDataInicial.setDate(novaDataInicial.getDate() - 1);
      this.data_inicial = novaDataInicial;
    }
  }

  getMinDateFinal(): Date {
    if (this.data_inicial) {
      const minDate = new Date(this.data_inicial);
      minDate.setDate(minDate.getDate() + 1);
      return minDate;
    }
    return null;
  }

  getMaxDateFinal(): Date {
    if (this.data_inicial) {
      const maxDate = new Date(this.data_inicial);
      maxDate.setMonth(maxDate.getMonth() + 12);
      return maxDate;
    }
    return null;
  }

  protected getListagemComFiltros(): boolean {
    return false;
  }
}